import type { ReactNode } from "react";

import classNames from "classnames/bind";

import styles from "./CarouselContainer.module.scss";

export interface CarouselContainerProps {
    children: ReactNode | ReactNode[];
    className?: string;
}

const cx = classNames.bind(styles);

const CarouselContainer = ({ children, className }: CarouselContainerProps) => {
    return <div className={cx("carouselContainer", className)}>{children}</div>;
};

export default CarouselContainer;
